import React from 'react';

import togglesSet from './constants/togglesSet';
import ShowCase from '@components/ShowCase/ShowCase';
import Preview from '@components/ShowCase/Preview/Preview';
import Controls from '@components/ShowCase/Controls/Controls';

const Toggles = () => (
  <section>
    <article>
      <ul className="showcase-list">
        {
          togglesSet.map((togglesPreview, i) => (
            <li key={`toggles-showcase-${i}`}>
              <ShowCase codeTemplate={togglesPreview.codeTemplate}>
                <Preview className={togglesPreview.previewClass}>
                  { togglesPreview.component }
                </Preview>
                <Controls optionsGroup={togglesPreview.optionsGroup}  />
              </ShowCase>
            </li>
          ))
        }
      </ul>
    </article>
  </section>
);

Toggles.displayName = 'TogglesPage';

export default Toggles;



// WEBPACK FOOTER //
// ./src/containers/elements/Toggles/Toggles.js